"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 21.01.2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of PromoBaselineOutput
 * @author ZSr
 */


var PromoBaselineOutputConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromoBaselineOutputConverter, _DataObjectConverter_);

  function PromoBaselineOutputConverter() {
    _classCallCheck(this, PromoBaselineOutputConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoBaselineOutputConverter).apply(this, arguments));
  }

  return PromoBaselineOutputConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromoBaselineOutputConverter = PromoBaselineOutputConverter;